import siteConfig from "../config/siteConfig";

export const formatCurrency = (
  value,
  currency = siteConfig.currency,
  locale = siteConfig.locale
) =>
  new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  }).format(value);

export const slugify = (value) =>
  value.toLowerCase().trim().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
